import { ApiError } from '@/lib/api/errors'

import { fetchProfile, saveProfile } from './api'
import { isProfileComplete, type Profile, type SaveProfileInput } from './schema'

function matchesProfile(saved: Profile, input: SaveProfileInput) {
  const address = saved.favorite_address
  return (
    isProfileComplete(saved) &&
    saved.jastip_name === input.jastip_name &&
    saved.gender === input.gender &&
    saved.job === input.job &&
    JSON.stringify(saved.social_media_urls) === JSON.stringify(input.social_media_urls) &&
    address?.is_favorite === true &&
    address.id === saved.favorite_address_id &&
    address.label === input.label &&
    address.route_id === input.route_id &&
    address.address === input.address &&
    address.additional_address === input.additional_address &&
    (input.latitude === undefined || Math.abs(address.latitude - input.latitude) < 0.000001) &&
    (input.longitude === undefined || Math.abs(address.longitude - input.longitude) < 0.000001)
  )
}

/** One PUT owns profile/address creation; retry a failed confirmation without repeating the write. */
export function createProfileCompletionSaver(assertAccount: () => void) {
  let savedKey: string | undefined
  let uncertainKey: string | undefined
  let confirmed: Profile | undefined
  return async (input: SaveProfileInput) => {
    assertAccount()
    const key = JSON.stringify(input)
    if (savedKey === key && confirmed) return confirmed
    if (savedKey !== key && uncertainKey !== key) {
      try {
        const response = await saveProfile(input)
        assertAccount()
        savedKey = key
        confirmed = undefined
        if ('favorite_address_id' in response && matchesProfile(response, input)) {
          confirmed = response
          return confirmed
        }
      } catch (error) {
        if (
          !(error instanceof ApiError) ||
          error.status === 0 ||
          error.status >= 500 ||
          error.status === 408 ||
          error.status === 499
        )
          uncertainKey = key
        throw error
      }
    }
    assertAccount()
    const refreshed = await fetchProfile()
    assertAccount()
    if (!matchesProfile(refreshed, input)) {
      throw new Error(
        'Data tersimpan, tetapi alamat favorit belum terkonfirmasi. Silakan coba simpan kembali.',
      )
    }
    savedKey = key
    confirmed = refreshed
    return confirmed
  }
}
